<template>
  <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0H1V14H0V0Z" fill="currentColor"/>
    <path d="M14 13V14H0V13H14Z" fill="currentColor"/>
    <path
        d="M2 7.72426C2 7.45699 2.32314 7.32314 2.51213 7.51213L3.91213 8.91213C3.96839 8.96839 4 9.0447 4 9.12426V11.7C4 11.8657 3.86569 12 3.7 12H2.3C2.13431 12 2 11.8657 2 11.7V7.72426Z"
        fill="currentColor"/>
    <path
        d="M7 7.72426C7 7.45699 6.67686 7.32314 6.48787 7.51213L5.08787 8.91213C5.03161 8.96839 5 9.0447 5 9.12426V11.7C5 11.8657 5.13431 12 5.3 12H6.7C6.86569 12 7 11.8657 7 11.7V7.72426Z"
        fill="currentColor"/>
    <path
        d="M10 4.72426C10 4.45699 9.67686 4.32314 9.48787 4.51213L8.08787 5.91213C8.03161 5.96839 8 6.0447 8 6.12426V11.7C8 11.8657 8.13431 12 8.3 12H9.7C9.86569 12 10 11.8657 10 11.7V4.72426Z"
        fill="currentColor"/>
    <path
        d="M13 1.72426C13 1.45699 12.6769 1.32314 12.4879 1.51213L11.0879 2.91213C11.0316 2.96839 11 3.0447 11 3.12426V11.7C11 11.8657 11.1343 12 11.3 12H12.7C12.8657 12 13 11.8657 13 11.7V1.72426Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconChartLine"
}
</script>
